module.exports = __webpack_public_path__ + "img/icon-48.208998c8.svg";